import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeInUp, staggerContainer } from './ui/Section';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section darker id="problem" data-id="element-87">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} className="max-w-4xl mx-auto" data-id="element-88">
        <motion.div variants={fadeInUp} className="text-center mb-16" data-id="element-89">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-90">
            ¿Cansada de Fajas que{' '}
            <span className="text-red-500" data-id="element-91">No Cumplen</span>?
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent mx-auto mb-8" data-id="element-92"></div>

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-93">
            Si eres una mujer plus size viviendo en Estados Unidos, has pasado
            por esto: compraste fajas que prometían mucho, pero no se ajustaban
            a tu cuerpo, se enrollaban, no moldeaban tus curvas y terminabas
            guardándolas en un cajón.
          </p>

          <p className="text-lg md:text-xl text-white font-medium leading-relaxed" data-id="element-94">
            Hoy, eso se acaba. Te traemos una faja colombiana original, diseñada
            para tallas 2XL a 5XL, con todos los secretos que necesitas para
            usarla con confianza.
          </p>
        </motion.div>

        <motion.div variants={fadeInUp} className="bg-dark-800 p-8 md:p-10 rounded-2xl border border-red-900/30 shadow-2xl" data-id="element-95">
          <h3 className="text-xl md:text-2xl font-serif text-white mb-8 border-l-4 border-red-600 pl-4" data-id="element-96">
            Muchas mujeres plus size han gastado cientos de dólares en fajas que
            no eran colombianas. Fajas que:
          </h3>

          <ul className="space-y-6" data-id="element-97">
            {['No están hechas para cuerpos curvy ni tallas grandes.', 'Usan materiales baratos que no ofrecen soporte real.', 'No te dan las instrucciones exactas para elegir la talla correcta.', 'No te ofrecen ninguna ayuda personalizada cuando tienes preguntas o problemas.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-98">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-99" />
                <span className="text-gray-300 text-lg" data-id="element-100">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </motion.div>
    </Section>;
}